import React from "react";
import "./Banners.css";
import { NavLink } from "react-router-dom";
import Slider from "react-slick";
import { buildSeoPath } from "../../Utils/routes";

const Banners = ({ data }) => {
  var settings = {
    centerMode: true,
    centerPadding: "60px",
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          centerPadding: "30px",
        },
      },
      {
        breakpoint: 766,
        settings: {
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: "30px",
        },
      },
    ],
  };

  return (
    <>
      <div className="banners-container">
        <div className="container">
          <Slider {...settings}>
            {data?.map((sliderItem) => {
              const slug = sliderItem?.sub_slug || sliderItem?.promo_slug || sliderItem?.promotional_slug || sliderItem?.promotional_category__slug || sliderItem?.prom_slug;
              const bannerPath = slug
                ? buildSeoPath(slug)
                : "#";

              return (
                <div className="banner-item" key={sliderItem.id}>
                  <NavLink to={bannerPath}>
                    <div className="banner-img">
                      <img
                        src={
                          sliderItem.image__image
                            ? sliderItem.image__image
                            : sliderItem.image
                        }
                        alt={sliderItem?.title || "banner"}
                      />
                    </div>
                  </NavLink>
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    </>
  );
};
export { Banners };
